import { environment as devEnv } from './environment';

export const environment = {
  ...devEnv,
  production: false,
  msalConfig: {
    auth: {
      clientId: '6b858b14-b271-4c93-b879-d85f9ef0e1bc',
      authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
      scopes: ['User.Read'],
    },
  },
  apiConfig: {
    graph_api: {
      scopes: ['User.Read'],
      uri: 'https://graph.microsoft.com/v1.0/me',
    },
    articleplan_api: {
      scopes: ['4e21e816-2d5f-4312-a886-9f481d94bfb5/ArticlePlan.API.ReadWrite'],
      uri: 'https://tdarticleplan-app-dev.delightfulglacier-192f74d0.swedencentral.azurecontainerapps.io',
    },
  },
  timeouts: {
    toastMs: 5000,
  },
  externalApps: {
    assortmentCanvas: 'https://assortmentcanvas-sit.azurewebsites.net/',
    assortmentOverview: 'https://hm-assortmentoverviewui-sit.azurewebsites.net/',
    productPlan: 'https://sit.productplan.hm.com/',
    assortmentSupportLearning:
      'https://hmgroup.atlassian.net/wiki/spaces/spbads/pages/3698491436/App+Menu+NEW',
  },
};
